const buyBox = document.querySelector('.js-buy-box');
const footer = document.querySelector('.js-footer');

document.addEventListener("click", function(e)
{
  var target = e.target;

  if(target.tagName !== "BUTTON" && !target.classList.contains("js-buy-box-btn"))
    return;

  target.classList.toggle("js-active");
  target.parentElement.classList.toggle("js-active");
});

if (buyBox && footer)
{
  window.onload = () =>
  {
    if (window.matchMedia('(max-width: 1068px)').matches)
    {
      const height = buyBox.offsetHeight;
      footer.style.paddingBottom = `${height}px`;
    }
  };
}
